import {ApiJsonResult} from '../../utils/api/apijsonresult';
import {StringUtils} from '../../utils/string.utils';

export class Editt {
    id: number;
    technique: string;
    description: string;
    videoUrl: string;
    imageUrl: string;
    createdBy: string;
    createdDate: Date;
    updatedBy: string;
    updatedDate: Date;

    static populate(jsonObject: any): Editt {
        const obj = new Editt();
        obj.id = jsonObject.id;
        obj.technique = jsonObject.technique;
        obj.description = jsonObject.description;
        obj.videoUrl = jsonObject.videoUrl;
        obj.imageUrl = jsonObject.imageUrl;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): Editt {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = Editt.populate(jsonObject);
        }
        return obj;
    }

}
